import phone from 'phone';

export const isPhoneValid = (phoneValue) => {
  return phone(phoneValue.startsWith('+') ? phoneValue : `+${phoneValue}`).isValid;
};
